// Mobile uses two decimal places for currency and accepts both ETA field names.
export function formatOfferAmount(value) {
  const amount = Number(value);
  return value == null || value === '' || !Number.isFinite(amount) ? '—' : new Intl.NumberFormat('en', { useGrouping: false, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
}

export const availableOfferCount = (offers) => (offers || []).filter((offer) => Number(offer.OfferStatus) === 0).length;

export function readOfferEta(offer, kind) {
  const fields = kind === 'pickup'
    ? ['pickup_estimated_time', 'estimated_pickup_time']
    : ['delivery_estimated_time', 'estimated_delivery_time'];
  return fields.map((field) => offer?.[field]).find((value) => typeof value === 'string' && value.trim())?.trim() || null;
}

export function formatOfferEta(raw, language = 'en') {
  if (!raw?.trim()) return null;
  const value = raw.trim();
  const timeOnly = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(value);
  if (timeOnly) {
    const hour = Number(timeOnly[1]), minute = Number(timeOnly[2]);
    if (hour > 23 || minute > 59) return value;
    return new Intl.DateTimeFormat(language?.startsWith('ar') ? 'ar-AE' : 'en-AE', {
      hour: 'numeric', minute: '2-digit', timeZone: 'UTC',
    }).format(new Date(Date.UTC(1970, 0, 1, hour, minute)));
  }
  // Server times without an offset refer to UAE local time. Do not interpret
  // them in the browser's timezone or invent a date for a time-only estimate.
  const normalized = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(value)
    && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value) ? `${value.replace(' ', 'T')}+04:00` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(language?.startsWith('ar') ? 'ar-AE' : 'en-AE', {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Dubai',
  }).format(date);
}
